import { TODOS_LOS_PERMISOS } from "./permisos";

/**
 * Confirma "Marcar todo" / "Quitar todo" antes de tocar las casillas. No guarda nada: los cambios
 * se aplican al pulsar Guardar. (Antes el interruptor "Acceso total" cambiaba todo de un clic.)
 * @param {Function} pedirConfirmacion `pedir` de useConfirmacion.
 * @param {boolean} valor true para marcar todo; false para quitar todo.
 * @param {Function} setPermisos
 */
export const pedirTodo = (pedirConfirmacion, valor, setPermisos) =>
  pedirConfirmacion({
    titulo: valor ? "Marcar todos los permisos" : "Quitar todos los permisos",
    mensaje: valor
      ? `Se marcarán los ${TODOS_LOS_PERMISOS.length} permisos: los usuarios con este rol podrán ver y hacer todo en el sistema. Se aplica al guardar.`
      : "Se quitarán todos los permisos: los usuarios con este rol no podrán ver ni hacer nada. Se aplica al guardar.",
    textoConfirmar: valor ? "Marcar todo" : "Quitar todo",
    peligro: !valor,
    onConfirmar: () =>
      setPermisos(Object.fromEntries(TODOS_LOS_PERMISOS.map((d) => [d, valor]))),
  });
